import React, {useContext} from 'react'
import {dataContext,localestr} from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js';
import EditTemplates from '../cmp/EditTemplates.js';

function CatDevices3Edit({data,actions}){
    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const tabClose=actions.tabClose

    const context=useContext(dataContext)
    const saveData=context.saveData
    const msg=context.msg

    const setValue=(name,data)=>{
        let newData={...wndData}
        newData.changed=true
        if (data==='') newData[name]=null
        else newData[name]=data
        setWndData(newData)
    }

    const update=(d)=>{
        let newData={...wndData,...d.data,changed:false}
        setWndData(newData)
        //tabClose()
    }

    const saveValue=(action=()=>{})=>{
        if(!wndData.changed) {action({});return}
        let errmsg=''
        const name=(wndData.name || '').substring(0,64)
        if (name===null || name==='') errmsg=localestr("Не заповнено ім'я")
        if (errmsg!=='') msg(errmsg,localestr('Помилка'),[{caption:'OK',action:()=>{}}])
        else{
            let data={type:''+wndData.device,name}
            if(wndData.id) data.id=wndData.id
            if(wndData.templates) data.templates=wndData.templates
            let newData={status:'mod',key:'CatDevices',data}
            saveData(newData,action)
        }

    }

    return(
    <div style={{display:'flex',flexDirection:'column', margin:'4px 0',alignSelf:'flex-start',flexGrow:'10000'}}>
        <div style={{margin:'2px 0',display:'inherit'}}>
    <EditCtrl Capt={'Id'} Value={wndData.id} typeVal={'text'} setVal={(d)=>{setValue('id',d)}} width1='43' width2='50' disabled={true}/>
    <div style={{width:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
    <EditCtrl Capt={localestr('Назва')} Value={wndData.name} typeVal={'text'} setVal={(d)=>{setValue('name',d)}} width1='50' width2='186'/>
        </div>
    <EditTemplates Capt={localestr('Файли шаблонів')} Value={wndData.templates} setVal={(d)=>{setValue('templates',d)}} width1='127' width2='213' />
    <div style={{margin:'2px 0',display:'inherit'}}>
        <div style={{width:'60px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{saveValue(tabClose)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
        <div style={{width:'90px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{saveValue(update)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Зберегти')}</div></div>
    </div>
    </div>
    )
    
}

export default CatDevices3Edit